import React, { useState } from "react";

export const BaliSelect = ({current}) => {
  const [selectedDate, setSelectedDate] = useState(current);

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setSelectedDate(selectedDate);
    // Redirect to the corresponding link based on the selected date
    window.location.href = `https://register.thetravelsquad.com/${selectedDate}`;
  };

  return (
    <div>
      <select className="w-full p-2 border rounded" id="dateSelect" value={selectedDate} onChange={handleDateChange} style={{ fontWeight: 'bold', marginLeft: -4}}>
        <option value="bali-villa-week">23rd August - 30th August</option>
        <option value="bali-villa-week2">13th September - 20th September</option>
      </select>
    </div>
  );
};
